export const toggleModal = "toggleModal"
export const ADD_SHIFT_TO_LIST = "ADD_SHIFT_TO_LIST"
export const UPDATE_SHIFT_IN_LIST = "UPDATE_SHIFT_IN_LIST"
export const DELETE_SHIFT_FROM_LIST = "DELETE_SHIFT_FROM_LIST"
export const ADD_SHIFTS_TO_LIST = "ADD_SHIFTS_TO_LIST"
